// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"jgy_45z","sellerDetails":"jgy_45z","seller-name":"mg76RuK","sellerName":"mg76RuK","badge":"aZwy91i","promoted-gig-text":"dSsv_87","promotedGigText":"dSsv_87"};